
import { Component, Prop, Vue } from "vue-property-decorator";
import { QuestionV2 } from "@/lib/model/exambuilder/question-v2";
import AppendAskConfig, {
  EnumQuestionAppendAIGCAskType,
  EnumQuestionAppendAskType,
  EnumQuestionAppendConditionType,
  ReplyCheckpointList,
  ReplyFixedSpeechList,
  RuleAsk
} from "@/lib/model/exambuilder/inquiry";

// 条件追问项
class ReplyCheckpoints {
  checkpointName = ""; //   `json:"checkpointName"` // 触发条件
  replyTextList = ""; // `json:"replyTextList"`  // 追问话术
}

// 固定话术
class ReplyFixedSpeech {
  replyTextList = "";
  loading = false;
}

class AppendAskRules {
  conditionType = EnumQuestionAppendConditionType.Count;
  aigcType = EnumQuestionAppendAIGCAskType.GPT; // AIGC追问配置类型
  type = EnumQuestionAppendAskType.EnumQuestionAppendAskTypeAIGC; // 追问配置类型
  replyFixedSpeechList = [new ReplyFixedSpeech()]; // 固定追问-追问话术列表
  replyTextPrefix = ""; //    string `json:"replyTextPrefix"` // AIGC追问-前置追问话术
  replyCheckpointList: ReplyCheckpoints[] = [new ReplyCheckpoints()]; //条件追问
  wordLimit1 = 0; //题干回答字数左
  wordLimit2 = 0; //题干回答字数右
  poppycockReplyText = "";
  aigcMeaninglessLoading = false;
}

@Component({})
export default class Inquiry extends Vue {
  @Prop({}) question!: QuestionV2;
  @Prop({ default: false, type: Boolean }) visible!: boolean;

  askInfo = {
    isAppendAsk: false, //是否追问 0：不限制；1:追问；2:不追问；
    ruleList: [new AppendAskRules()]
  };
  radioEnum = EnumQuestionAppendAskType;
  conditionTypeEnum = EnumQuestionAppendConditionType;
  aigcTypeEnum = EnumQuestionAppendAIGCAskType;
  conditionTypeOptions = [
    {
      label: "固定100%触发",
      value: EnumQuestionAppendConditionType.Const
    },
    {
      label: "按回答字数触发",
      value: EnumQuestionAppendConditionType.Count
    }
  ];
  number = 0;

  mounted() {
    this.getQuestion(this.question);
  }

  async getQuestion(q: QuestionV2) {
    this.askInfo.isAppendAsk = q.isAppendAsk === 1;
    this.number = (await this.question.getAnswerNumber()) as number;
    this.askInfo.ruleList = q.appendAskConfig.ruleList.map(item => {
      const rule = new AppendAskRules();
      rule.conditionType = item.conditionType;
      rule.type = item.type;
      rule.aigcType = item.aigcType;
      rule.replyTextPrefix = item.replyTextPrefix;
      rule.replyFixedSpeechList = !item.replyFixedSpeechList.length
        ? [new ReplyFixedSpeech()]
        : item.replyFixedSpeechList.map(r => ({
            replyTextList: r.replyTextList.join("\n"),
            loading: false
          }));
      rule.replyCheckpointList = !item.replyCheckpointList.length
        ? [new ReplyCheckpoints()]
        : item.replyCheckpointList.map(text => {
            const replyCheckpoint = new ReplyCheckpoints();
            replyCheckpoint.checkpointName = text.checkpointName;
            replyCheckpoint.replyTextList = text.replyTextList.join("\n");
            return replyCheckpoint;
          });
      rule.wordLimit1 = item.wordLimit[0] || 0;
      rule.wordLimit2 = item.wordLimit[1] || 0;
      rule.poppycockReplyText = item.poppycockReplyTextList.join("\n");
      return rule;
    });
  }

  moveAsk(direction: number, i: number) {
    const list1 = { ...this.askInfo.ruleList[i] };
    const list2 = { ...this.askInfo.ruleList[i + direction] };

    Object.assign(this.askInfo.ruleList[i], list2);
    Object.assign(this.askInfo.ruleList[i + direction], list1);
    this.$forceUpdate();
  }

  // 更改追问条件
  handleChangeConditionType(item: AppendAskRules) {
    if (item.conditionType !== EnumQuestionAppendConditionType.Const) return;

    item.type = EnumQuestionAppendAskType.EnumQuestionAppendAskTypeConst;
  }

  // 获取追问demo
  async getAskDemo() {
    try {
      const textList = (await AppendAskConfig.get(
        this.question.descTextOnly
      )) as string[];

      return textList.join("\n");
    } catch (error) {
      this.$message.warning("获取追问demo失败");
      return "";
    }
  }

  async getAppendAskText(i: number, round: number) {
    const roundItem = this.askInfo.ruleList[i].replyFixedSpeechList[round];
    roundItem.loading = true;
    const textListStr = await this.getAskDemo();
    const text = roundItem.replyTextList.length
      ? `\n${textListStr}`
      : textListStr;
    roundItem.replyTextList += text;
    roundItem.loading = false;
  }

  async getPoppycockReplyText(i: number) {
    const roundItem = this.askInfo.ruleList[i];
    roundItem.aigcMeaninglessLoading = true;
    const textListStr = await this.getAskDemo();
    const text = roundItem.poppycockReplyText.length
      ? `\n${textListStr}`
      : textListStr;
    roundItem.poppycockReplyText += text;
    roundItem.aigcMeaninglessLoading = false;
  }

  // 添加追问规则
  addAppendAskRule() {
    this.askInfo.ruleList.push(new AppendAskRules());
  }
  // 删除追问规则
  deleteAppendAskRule(index: number) {
    this.askInfo.ruleList.splice(index, 1);
  }

  // 添加话术轮次
  addSpeechRound(askItem: AppendAskRules) {
    askItem.replyFixedSpeechList.push(new ReplyFixedSpeech());
  }
  // 删除话术轮次
  deleteSpeechRound(askItem: AppendAskRules, index: number) {
    this.$confirm("删除后已编写追问话术无法被找回，是否确认删除？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(() => {
      askItem.replyFixedSpeechList.splice(index, 1);
    });
  }

  // 添加条件追问
  addReplyCheckpoint(parentIndex: number) {
    this.askInfo.ruleList[parentIndex].replyCheckpointList.push(
      new ReplyCheckpoints()
    );
  }
  // 删除条件追问
  deleteReplyCheckpoint(parentIndex: number, i: number) {
    this.askInfo.ruleList[parentIndex].replyCheckpointList.splice(i, 1);
  }

  // 输入内容处理
  inputChange(value: string, type: number, askItem?: any, key?: string) {
    if (type && key) {
      //数字
      const v1 = (askItem[key + 1] = Math.ceil(+askItem[key + 1]));
      const v2 = (askItem[key + 2] = Math.ceil(+askItem[key + 2]));
      if (v2 < v1) {
        askItem[key + 2] = v1;
      }
    } else {
      //文本域
      if (!value.length) {
        this.$message.warning("追问话术不能为空！");
      }
    }
  }

  close() {
    this.unVisible();
  }
  unVisible() {
    this.$emit("update:visible", false);
  }
  // 追问规则配置保存
  askSubmit() {
    const next =
      this.askInfo.ruleList.length &&
      this.askInfo.ruleList.every(item => {
        return this.checkAskTextEmpty(item);
      });
    if (!this.askInfo.isAppendAsk || next) {
      this.checkAskText();
      this.question.isAppendAsk = Number(this.askInfo.isAppendAsk);
      AppendAskConfig.updateAppendAsk({
        questionId: this.question.questionId,
        isAppendAsk: this.question.isAppendAsk,
        appendAskConfig: this.question.appendAskConfig
      })
        .then(() => {
          this.$message.success("设置成功");
        })
        .catch((error: any) => {
          this.$message.error(error.data.message);
        });
      this.unVisible();
    } else {
      this.$message.warning("追问话术不能为空！");
    }
  }
  // 判断选中项追问话术不能为空
  checkAskTextEmpty(itemRule: AppendAskRules) {
    if (
      itemRule.type === EnumQuestionAppendAskType.EnumQuestionAppendAskTypeConst
    ) {
      return itemRule.replyFixedSpeechList.every(item => {
        return !!item.replyTextList.length;
      });
    }
    if (
      itemRule.type === EnumQuestionAppendAskType.EnumQuestionAppendAskTypeAIGC
    ) {
      return !!itemRule.replyTextPrefix;
    }
    if (
      itemRule.type ===
      EnumQuestionAppendAskType.EnumQuestionAppendAskTypeSwitch
    ) {
      return (
        itemRule.replyCheckpointList.length &&
        itemRule.replyCheckpointList.every(check => {
          return check.checkpointName && check.replyTextList.length;
        })
      );
    }
    return false;
  }
  // 数据处理
  checkAskText() {
    this.question.appendAskConfig.ruleList = this.askInfo.ruleList.reduce(
      (pre, itemRule) => {
        const ruleAsk = new RuleAsk();
        ruleAsk.type = itemRule.type;
        ruleAsk.aigcType = itemRule.aigcType;
        ruleAsk.conditionType = itemRule.conditionType;
        ruleAsk.wordLimit = [+itemRule.wordLimit1, +itemRule.wordLimit2];
        ruleAsk.replyFixedSpeechList = itemRule.replyFixedSpeechList.map(
          (item, index) => {
            const replyFixedSpeech = new ReplyFixedSpeechList();
            replyFixedSpeech.roundNumber = index + 1;
            replyFixedSpeech.replyTextList = item.replyTextList.length
              ? item.replyTextList.trim().split("\n")
              : [];
            return replyFixedSpeech;
          }
        );
        ruleAsk.replyTextPrefix = itemRule.replyTextPrefix;
        ruleAsk.replyCheckpointList = itemRule.replyCheckpointList.reduce(
          (checkpointList, cur) => {
            const replyCheckpoint = new ReplyCheckpointList();
            if (cur.checkpointName && cur.replyTextList.length) {
              replyCheckpoint.checkpointName = cur.checkpointName;
              replyCheckpoint.replyTextList = cur.replyTextList
                .trim()
                .split("\n");
              checkpointList.push(replyCheckpoint);
            }
            return checkpointList;
          },
          [] as ReplyCheckpointList[]
        );
        ruleAsk.poppycockReplyTextList = itemRule.poppycockReplyText
          .trim()
          .split("\n");
        pre.push(ruleAsk);
        return pre;
      },
      [] as RuleAsk[]
    );
  }
}
